var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.modules),function(module){return [_c(_vm.dripMode,{key:module.encoded_id,tag:"component",attrs:{"module":module}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }